// src/components/common/SaveButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk } from '@/icons';
import LoadingButton from './LoadingButton';
import './SaveButton.css';

interface SaveButtonProps {
  isLoading: boolean;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  label?: string; // Adicionada para texto dinâmico, com fallback para " Salvar"
}

const SaveButton: React.FC<SaveButtonProps> = ({
  isLoading,
  onClick,
  disabled = false,
  className = '',
  label, // Adicionada para texto dinâmico
}) => {
  return (
    <LoadingButton
      isLoading={isLoading}
      onClick={onClick}
      disabled={disabled}
      className={`save-button ${className}`}
    >
      <FontAwesomeIcon icon={faFloppyDisk} /> {label || 'Salvar'}
    </LoadingButton>
  );
};

export default SaveButton;
